import styled from 'styled-components'
import Button from 'react-bootstrap/Button'

export const Options = styled.div`
  display: flex;
  flex-wrap: wrap;
  height: auto;
  width: 100%;
  flex-direction: column;
`

interface OptionProps {
  isSelected?: boolean
  isInCorrect?: boolean
}

export const Option = styled.div<OptionProps>`
  display: flex;
  > * {
    margin-right: 8px !important;
    > * {
      height: auto !important;
    }
  }
  padding: 8px;
  cursor: pointer;
  &:hover,
  &:focus {
    background: ${({ theme }) => theme.answer?.selected};
  }
  border-radius: 10px;
  margin-top: 12px;
  background: ${({ isSelected, theme, isInCorrect }) =>
    isSelected
      ? theme.answer?.selected
      : isInCorrect
      ? theme.answer?.inCorrect
      : 'none'};
`

export const SolutionWrapper = styled.div`
  margin: 24px 0;
`

export const ReportButton = styled(Button)`
  width: 100px;
  margin: auto;
  margin-right: 0;
`
